import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNotification } from '../contexts/NotificationContext';
import { apiService } from '../services/ApiService';
import API_URLS from '../services/apiConfig';
import '../styles/AddCollaborators.css';

const AddCollaborators = () => {
  const { currentUser } = useAuth();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    username: '',
    senha: '',
    confirmarSenha: ''
  });
  const [errors, setErrors] = useState({});

  // Função para validar o domínio do email corporativo
  const validateCorporateEmail = (email) => {
    if (!email) return false;
    const userDomain = currentUser.email.split('@')[1];
    const newUserDomain = email.split('@')[1];
    return userDomain === newUserDomain;
  };

  // Função para validar o formulário
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.nome) {
      newErrors.nome = 'Nome é obrigatório';
    }
    
    if (!formData.email) {
      newErrors.email = 'Email é obrigatório';
    } else if (!validateCorporateEmail(formData.email)) {
      newErrors.email = 'Email deve pertencer ao domínio corporativo';
    }
    
    if (!formData.username) {
      newErrors.username = 'Nome de usuário é obrigatório';
    }
    
    if (!formData.senha) {
      newErrors.senha = 'Senha é obrigatória';
    } else if (formData.senha.length < 6) {
      newErrors.senha = 'Senha deve ter pelo menos 6 caracteres';
    }
    
    if (formData.senha !== formData.confirmarSenha) {
      newErrors.confirmarSenha = 'As senhas não coincidem';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Função para lidar com mudanças nos campos do formulário
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Limpa o erro do campo quando ele é modificado
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Função para lidar com o envio do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      // Preparar dados do colaborador
      const userData = {
        ...formData,
        empresa: currentUser.empresa || '', // Adicionar empresa do usuário atual
        role: 'user', // Definir role padrão como usuário comum
        roleEmpresa: 'colaborador', // Definir papel na empresa
        tipoPlano: 'PLANO MENSAL', // Tipo de plano padrão para colaboradores
        status: true, // Usuário ativo
        data_criacao: new Date().toISOString() // Data de criação
      };
      
      // Usar o apiService para criar um novo usuário
      const result = await apiService.signup(userData);

      if (!result.success) {
        throw new Error(result.error || 'Erro ao criar colaborador');
      }

      showNotification('Colaborador criado com sucesso!', 'success');
      setFormData({
        nome: '',
        email: '',
        username: '',
        senha: '',
        confirmarSenha: ''
      });
    } catch (error) {
      showNotification(error.message || 'Erro ao criar colaborador', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-collaborators">
      <h2>Adicionar Novo Colaborador</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="nome">Nome Completo</label>
          <input
            type="text"
            id="nome"
            name="nome"
            value={formData.nome}
            onChange={handleChange}
            disabled={loading}
          />
          {errors.nome && <span className="error">{errors.nome}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email Corporativo</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            disabled={loading}
            placeholder={`exemplo@${currentUser.email.split('@')[1]}`}
          />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="username">Nome de Usuário</label>
          <input
            type="text"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            disabled={loading}
          />
          {errors.username && <span className="error">{errors.username}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="senha">Senha</label>
          <input
            type="password"
            id="senha"
            name="senha"
            value={formData.senha}
            onChange={handleChange}
            disabled={loading}
          />
          {errors.senha && <span className="error">{errors.senha}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="confirmarSenha">Confirmar Senha</label>
          <input
            type="password"
            id="confirmarSenha"
            name="confirmarSenha"
            value={formData.confirmarSenha}
            onChange={handleChange}
            disabled={loading}
          />
          {errors.confirmarSenha && <span className="error">{errors.confirmarSenha}</span>}
        </div>

        <button type="submit" className="btn-submit" disabled={loading}>
          {loading ? 'Criando...' : 'Criar Colaborador'}
        </button>
      </form>
    </div>
  );
};

export default AddCollaborators; 